<mat-toolbar class="main-header" [ngClass]="{'is-mobile-view': isMobileView}" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button (click)="onGoBack($event)" *ngIf="headerService.visibleBackButton">
    <mat-icon matTooltip="Go Back">arrow_back</mat-icon>
  </button>
  <span fxFlex style="overflow: hidden; text-overflow: ellipsis">
    <span class="title">{{title}}</span>
    <button class="beta-button" mat-flat-button *ngIf="headerService.isBetaMenu">BETA</button>
    <mat-icon *ngIf="headerService.showInfoIcon" (click)="headerService.infoIconClick.emit()"
              [matTooltip]="headerService.infoIconTooltip">info_outline</mat-icon>
  </span>

  <app-version-switch></app-version-switch>
  <button mat-icon-button type="button" *ngIf="isMobileView" [matMenuTriggerFor]="additionalMenu">
    <mat-icon class="header-icon">more_vert</mat-icon>
  </button>
  <mat-menu #additionalMenu="matMenu" >
    <a mat-menu-item matTooltip="View past release notes" href="https://telego.com/cpupdates/" target="_blank">
      <mat-icon fontSet="material-icons-outlined" class="header-icon">speaker_notes</mat-icon>
      Release Notes
    </a>
    <button mat-menu-item matTooltip="Refer a Business" (click)="onReferBusiness($event)">
      <mat-icon class="header-icon">card_giftcard</mat-icon>
      Refer a Business
    </button>
    <a mat-menu-item matTooltip="Contact Us" (click)="toggleHelpscout()">
      <mat-icon class="header-icon">help_outline</mat-icon>
      Contact Us
    </a>
    <button mat-menu-item matTooltip="Admin Settings" [routerLink]="[settingsUrl]" *ngIf="!!settingsUrl">
      <mat-icon class="header-icon">settings</mat-icon>
      Admin Settings
    </button>
  </mat-menu>

  <div *ngIf="!isMobileView" fxLayout="row" fxLayoutAlign="start center">
    <button mat-flat-button class="beta-button" matTooltip="Become beta customer" (click)="onBetaClick($event)"
            *ngIf="!isBetaCustomer && hasPermissionForBeta && headerService.hasBetaModules">Enable Beta
    </button>
    <button mat-flat-button class="beta-button" color="primary" matTooltip="Switch back to public version"
            (click)="onStableClick($event)" *ngIf="isBetaCustomer && hasPermissionForBeta && headerService.hasBetaModules">Disable Beta
    </button>
    <app-new-apps-popup></app-new-apps-popup>
    <a mat-icon-button matTooltip="View past release notes" href="https://telego.com/cpupdates/" target="_blank">
      <mat-icon fontSet="material-icons-outlined" class="header-icon">speaker_notes</mat-icon>
    </a>
    <button mat-icon-button matTooltip="Refer a Business" (click)="onReferBusiness($event)">
      <mat-icon class="header-icon">card_giftcard</mat-icon>
    </button>
    <a mat-icon-button matTooltip="Contact Us" (click)="toggleHelpscout()">
      <mat-icon class="header-icon">help_outline</mat-icon>
    </a>
    <button mat-icon-button matTooltip="Admin Settings" [routerLink]="[settingsUrl]" *ngIf="!!settingsUrl">
      <mat-icon class="header-icon">settings</mat-icon>
    </button>
  </div>
  <app-new-notifications></app-new-notifications>
  <app-new-current-user></app-new-current-user>
</mat-toolbar>
